import React from 'react'
import HouseImage1 from './Assets/Images/House1.jpeg';
import './App.css';

const Home = () => {
  return (
     <div
     className="w-full bg-cover bg-center relative min-h-[80vh] sm:min-h-[60vh] md:min-h-[70vh] lg:min-h-[100vh]"
     style={{
       backgroundImage: `url(${HouseImage1})`,
     }}
   >
     <div
       className="
         absolute inset-0 bg-black bg-opacity-50
         flex flex-col
         items-center justify-center
         sm:items-end sm:justify-center
         px-4 sm:px-8 text-center sm:text-right
       "
     >
       <div className="space-y-4 max-w-[95%] sm:max-w-[70%]">
       <h1 className="text-white text-5xl font-extrabold font-sans" data-aos="fade-down">
           RAM ENGINEER
         </h1>
         <h2 className="text-yellow-300 text-sm sm:text-lg lg:text-xl font-medium font-sans" data-aos="fade-right">
           COMPREHENSIVE CONSTRUCTION SOLUTIONS
         </h2>
         <h2 className="text-white text-base sm:text-xl lg:text-2xl font-semibold font-sans" data-aos="fade-up">
           Your Dream Home, Our Profession
         </h2>
       </div>
     </div>
   </div>
  )
}

export default Home
